import {
  useGetReportPlaceLazyQuery,
  useGetReportPostsByPlaceLazyQuery,
  useGetReportRequiredToolsLazyQuery,
  useGetReportServiceLazyQuery,
  useGetReportToolsInsuranceByIdLazyQuery,
  useGetReportToolsLazyQuery,
  useGetReportToolsMetrologicalLazyQuery,
  useGetReportWarehouseLazyQuery,
  useSetAddValuesNotesMutation,
  useSetAddValuesPersonalMutation,
  useSetAddValuesPlacePostsMutation,
  useSetAddValuesPlacesMutation,
  useSetAddValuesRequiredToolsMutation,
  useSetAddValuesSerivceMutation,
  useSetAddValuesToolsInsuranceMutation,
  useSetAddValuesToolsMetrologicalMutation,
  useSetAddValuesToolsMutation,
  useSetAddValuesTradePremisesMutation,
  useSetAddValuesWarehousesMutation,
  useSetDeleteSerivceMutation,
} from "~/schemas/generated/graphql";

interface IUseZDMutationsProps {
  selectedService: string;
}

export const useZDMutations = ({ selectedService }: IUseZDMutationsProps) => {
  const mutation = {
    services: selectedService === "services" && {
      change: useSetAddValuesSerivceMutation,
      report: useGetReportServiceLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "ServiceById",
    },
    requiredTools: selectedService === "requiredTools" && {
      change: useSetAddValuesRequiredToolsMutation,
      report: useGetReportRequiredToolsLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "RequiredToolsById",
    },
    toolsInsurance: selectedService === "toolsInsurance" && {
      change: useSetAddValuesToolsInsuranceMutation,
      report: useGetReportToolsInsuranceByIdLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "ToolsInsuranceById",
    },
    toolsMetrological: selectedService === "toolsMetrological" && {
      change: useSetAddValuesToolsMetrologicalMutation,
      report: useGetReportToolsMetrologicalLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "ToolsMetrologicalById",
    },
    tools: selectedService === "tools" && {
      change: useSetAddValuesToolsMutation,
      report: useGetReportToolsLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "ToolsById",
    },
    warehouses: selectedService === "warehouses" && {
      change: useSetAddValuesWarehousesMutation,
      report: useGetReportWarehouseLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "WarehouseById",
    },
    places: selectedService === "places" && {
      change: useSetAddValuesPlacesMutation,
      report: useGetReportPlaceLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "PlaceById",
    },
    placePosts: selectedService === "placePosts" && {
      change: useSetAddValuesPlacePostsMutation,
      report: useGetReportPostsByPlaceLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "PostsByPlace",
      placeReport: "PostByPost",
    },
    personal: selectedService === "personal" && {
      change: useSetAddValuesPersonalMutation,
      report: useGetReportServiceLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "Personal",
    },
    notes: selectedService === "notes" && {
      change: useSetAddValuesNotesMutation,
      report: useGetReportServiceLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: undefined,
    },
    tradePremises: selectedService === "tradePremises" && {
      change: useSetAddValuesTradePremisesMutation,
      report: useGetReportServiceLazyQuery,
      deleteMut: useSetDeleteSerivceMutation,
      hashReport: "TradePremisesById",
    },
  };

  return mutation[selectedService];
};
